import React, { useContext, useEffect } from 'react';
import NavBar from './components/NavBar/NavBar';
import ItemListContainer from './components/ItemListContainer/ItemListContainer';
import ItemListContainerBrand from './components/ItemListContainer/ItemListContainerBrand';
import ItemListContainerOfertas from './components/ItemListContainer/ItemListContainerOfertas';
import ItemListContainerNovedades from './components/ItemListContainer/ItemListContainerNovedades';
import ItemListContainerSearch from './components/ItemListContainer/ItemListContainerSearch';
import ItemListContainerSearchDrawer from './components/ItemListContainer/ItemListContainerSearchDrawer';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ItemDetailContainer from './components/ItemDetailContainer/ItemDetailContainer';
import { Container, useMediaQuery } from '@material-ui/core'
import HomePage2 from './components/HomePage2/HomePage2';
import Cart from './components/Cart/Cart';
import Return from './components/utils/Return';
import ScrollToTop from './components/utils/ScrollToTop';
import Login from './components/Login/Login';
import Register from './components/Register/Register';
import ProtectedRoutes from './components/ProtectedRoutes/ProtectedRoutes';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createTheme, ThemeProvider, responsiveFontSizes } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { CartContext } from './components/CartContext/CartContext';
import AlertMessage from './components/AlertMessage/AlertMessage';
import Order from './components/Order/Order';
import Downloads from "./components/Downloads/Downloads"
import PermanentDrawer2 from './components/NavBar/PermanentDrawer2'
import { Box } from '@material-ui/system';
import Footer from './components/Footer/Footer';
import Cookies from 'universal-cookie';
import { config, syncAuthCookie } from './config/config';

const authCookies = new Cookies();

function App() {
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const cartContext = useContext(CartContext);
	const {modeTheme}= cartContext;
  const isDarkTheme = modeTheme === 'dark';
  const isMobile = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    document.title = config.COMPANY_NAME
      ? `Catálogo y pedidos | ${config.COMPANY_NAME}`
      : 'Catálogo y pedidos';

    // Migrate a session created by a previous release from the catalog's
    // host-only cookie to the shared parent-domain cookie. This lets an
    // already authenticated administrator open the sibling admin subdomain
    // without having to log in a second time.
    ['token', 'user', 'IdVendedor'].forEach((name) => syncAuthCookie(authCookies, name));
  }, []);

  //  useEffect(() => {
  //    console.log("use effect en app");
  //  console.log(modeTheme);
  //  }, [modeTheme])
   

  let theme =  createTheme({
        palette: {
          // MUI v5 uses `mode`; keep `type` for legacy components.
          mode: isDarkTheme ? 'dark' : 'light',
          type: isDarkTheme ? 'dark' : 'light',
          // Almaferr palette: navy from the mark, graphite from the wrench,
          // and a restrained amber accent for calls to action.
          primary: isDarkTheme
            ? {
              // Keep links readable on the dark canvas; the fixed AppBars
              // retain the deeper navy brand color below.
              main: '#8fb5e5',
              dark: '#6f96c8',
              light: '#bfd5f1',
              contrastText: '#0b1d34',
            }
            : {
              main: '#082b66',
              dark: '#051d49',
              light: '#2f568e',
              contrastText: '#ffffff',
            },
          secondary: {
            main: '#70757c',
            dark: '#4f545a',
            light: '#a0a5ab',
            contrastText: '#ffffff',
          },
          warning: {
            main: '#b7791f',
          },
          success: {
            main: '#3f7659'
          },
          text: isDarkTheme
            ? {
              primary: '#f4f7fb',
              secondary: '#c2ccda',
              disabled: 'rgba(244, 247, 251, 0.5)',
            }
            : {
              primary: '#1f2937',
              secondary: '#5b6572',
              disabled: 'rgba(31, 41, 55, 0.5)',
            },
          divider: isDarkTheme ? 'rgba(255,255,255,0.14)' : 'rgba(31,41,55,0.12)',
          background: isDarkTheme
            ? { default: '#111923', paper: '#1b2633' }
            : { default: '#f4f6f8', paper: '#ffffff' },
        },
        typography: {
          // Tell MUI what's the font-size on the html element is.
          htmlFontSize: 16,
          fontFamily: ['Open sans', 'sans-serif'].join(','),
          // fontFamily: ['Lato', 'sans-serif'].join(','),
          // fontFamily: ['Quicksand', 'sans-serif'].join(','),
          // fontFamily: ['Nunito', 'sans-serif'].join(','),
          // fontFamily: [
          //   '-apple-system',
          //   'BlinkMacSystemFont',
          //   '"Segoe UI"',
          //   'Roboto',
          //   '"Helvetica Neue"',
          //   'Arial',
          //   'sans-serif',
          //   '"Apple Color Emoji"',
          //   '"Segoe UI Emoji"',
          //   '"Segoe UI Symbol"',
          // ].join(','),
        },
      });

  theme = responsiveFontSizes(theme);

  return (
    // <CartContextProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline/>
        <BrowserRouter>
          <a className="skip-link" href="#contenido-principal">
            Saltar al contenido principal
          </a>
          <div id="back-to-top-anchor" />
          <NavBar />
          <ScrollToTop />
          <Box sx={{display:"flex", minHeight: "100vh"}}>
          {isMobile ? <></> : <PermanentDrawer2 />}
  
          <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, minHeight: "100vh", width: "100%" }}>
            <Container
              component="main"
              id="contenido-principal"
              tabIndex={-1}
              sx={{
                marginTop: "80px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                flexGrow: 1,
              }}
            >
              <Routes>
                <Route exact path="/" element={<HomePage2 />}/>
                <Route exact path="/login" element={<Login />}/>
                <Route exact path="/register" element={<Register />}/>
                <Route path="/home" element={<HomePage2 />} />
                <Route exact path="/category/:category" element={<ItemListContainer />} />
                <Route exact path="/brand/:brand" element={<ItemListContainerBrand />} />
                <Route exact path="/ofertas" element={<ItemListContainerOfertas />} />
                <Route exact path="/novedades" element={<ItemListContainerNovedades />} />
                <Route exact path="/:lista/category/:category" element={<ItemListContainer />} />
                <Route exact path="/search/:patron" element={<ItemListContainerSearch />} />
                <Route exact path="/searchDrawer" element={<ItemListContainerSearchDrawer />} />
                <Route exact path="/searchDrawer/:patron" element={<ItemListContainerSearchDrawer />} />
                <Route exact path="/detail/:sku" element={<ItemDetailContainer greeting="Lista de productos" initial={1} />} />

                <Route element={<ProtectedRoutes />}>
                  <Route exact path="/cart" element={<Cart />} />     
                  <Route exact path="/order" element={<Order />} />     
                  <Route exact path="/downloads" element={<Downloads />} />     
                  <Route exact path="/alert/:message" element={<AlertMessage />} />     
                </Route>
                <Route exact path="*" element={<Return />} /> 
              </Routes>
            </Container>
            <Footer />
          </Box>
          </Box>
        </BrowserRouter>
      </ThemeProvider>
    // </CartContextProvider>

  );
}

export default App;
